import { Routes } from '@angular/router';
import ExampleComponent from './example/example.component';
import { FlujoLayoutComponent } from '@shared/components/layouts/flujo-layout/flujo-layout.component';
import { authGuard } from '@core/utils/guards/auth.guard';
import { typeUserGuard } from '@core/utils/guards/type-user.guard';
import { superAdminGuard } from '@core/utils/guards/super-admin.guard';

export const routes: Routes = [
    {
        path: 'example',
        title: 'example',
        component: ExampleComponent
    },
    {
        path: 'not-found',
        title: 'not found',
        loadChildren: () => import('./pages/not-found-404/not-found-404.routes').then((m) => m.routes)
    },
    {
        path: 'check-out',
        title: 'check out',
        loadChildren: () => import('./pages/check-out/check-out.routes').then((m) => m.routes)
    },
    {
        path: 'pre-check-out',
        title: 'pre check out',
        loadChildren: () => import('./pages/pre-check-out/pre-check-out.routes').then((m) => m.routes)
    },
    {
        path: 'login',
        title: 'login',
        loadChildren: () => import('./pages/login/login.routes').then((m) => m.routes)
    },
    {
        path: 'admin',
        title: 'admin',
        component: FlujoLayoutComponent,
        canActivate: [authGuard, typeUserGuard],
        children: [
            {
                path: 'dashboard',
                title: 'Dashboard',
                loadChildren: () => import('./pages/dashboard/dashboard.routes').then((m) => m.routes),
            },
            {
                path: 'clients',
                title: 'Clients',
                loadChildren: () => import('./pages/admin-moduls/clients/clients.routes').then((m) => m.routes)
            },
            {
                path: 'clients-approvers',
                title: 'Clients approvers',
                loadChildren: () => import('./pages/admin-moduls/clients-approvers/clients-approvers.routes').then((m) => m.routes)
            },
            {
                path: 'voucher-programs',
                title: 'Voucher-programs',
                loadChildren: () => import('./pages/admin-moduls/voucher-programs/voucher-programs.routes').then((m) => m.routes)
            },
            {
                path: 'my-voucher-programs',
                title: 'My voucher programs',
                loadChildren: () => import('./pages/admin-moduls/voucher-programs/voucher-programs.routes').then((m) => m.routes)
            },
            {
                path: 'payment-gateways',
                title: 'Payment gateways',
                loadChildren: () => import('./pages/admin-moduls/payment-gateways/payment-gateways.routes').then((m) => m.routes)
            },
            {
                path: 'fx-rates',
                title: 'FX rates',
                loadChildren: () => import('./pages/admin-moduls/fx-rates/fx-rates.routes').then((m) => m.routes)
            },
            {
                // Matriz general, no por cliente: por eso vive en el módulo admin y
                // no en la sección de clientes como la matriz de mensajes.
                path: 'pricing-matrix',
                title: 'Pricing matrix',
                loadChildren: () => import('./pages/admin-moduls/pricing-matrix/pricing-matrix.routes').then((m) => m.routes)
            },
            {
                path: 'users',
                title: 'Users',
                loadChildren: () => import('./pages/admin-moduls/users/users.routes').then((m) => m.routes)
            },
            {
                path: 'blocked-bills',
                title: 'Blocked Bills',
                loadChildren: () => import('./pages/admin-moduls/blocked-bills/blocked-bills.routes').then((m) => m.routes)
            },
            {
                // Cuelga de 'admin' para heredar authGuard + typeUserGuard, aunque
                // en el dashboard sea un grupo aparte de Admin Modules.
                path: 'tools',
                title: 'Tools',
                loadChildren: () => import('./pages/tools/tools.routes').then((m) => m.routes)
            },
            {
                // Hereda authGuard + typeUserGuard de 'admin'; superAdminGuard solo
                // decide la navegacion, la API vuelve a exigir el grupo.
                path: 'super-admin',
                title: 'Super admin',
                canActivate: [superAdminGuard],
                loadChildren: () => import('./pages/super-admin/super-admin.routes').then((m) => m.routes)
            },
            {
                path: '**',
                redirectTo: 'admin/dashboard',
                pathMatch: 'full',
            },
        ]
    },
    {
        path: 'client',
        title: 'client',
        component: FlujoLayoutComponent,
        canActivate: [authGuard, typeUserGuard],
        children: [
            {
                path: 'dashboard',
                title: 'dashboard',
                loadChildren: () => import('./pages/dashboard/dashboard.routes').then((m) => m.routes)
            },
            {
                path: 'my-voucher-programs',
                title: 'my-voucher-programs',
                loadChildren: () => import('./pages/clients-moduls/my-voucher-programs/my-voucher-programs.routes').then((m) => m.routes)
            },
            {
                path: 'transactions-search',
                title: 'transactions-search',
                loadChildren: () => import('./pages/clients-moduls/transactions/transactions.routes').then((m) => m.routes)
            },
            {
                path: '**',
                redirectTo: 'client/dashboard',
                pathMatch: 'full',
            },
        ]
    },
    {
        // fuera del flujo de login porque el login ya se hizo y tampooco es un paso de la autenticacion.
        path: "change-password",
        title: "change-password",
        loadComponent: () => import("./pages/change-password/change-password.component").then((m) => m.ChangePasswordComponent)
    },
    {
        path: '**',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full'
    }
];
